export default {
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  directions: {
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# day} other {# days}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`
  },
  locations: {
    distance: "{distance, number, distance} {unit}"
  },
  info_window: {
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  fuels: {
    fuelsave_98: "Shell FuelSave 98",
    fuelsave_midgrade_gasoline: "Shell FuelSave 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_gasoline: "Shell V-Power Nitro+",
    shell_regular_diesel: "Shell Diesel"
  },
  amenities: {
    euroshell_card: "Shell Card ",
    service_bay: "AutoServ",
    shell_card: "Shell Card "
  }
}
